import { render, staticRenderFns } from "./DeliveryWuliu.vue?vue&type=template&id=cb4f5850&scoped=true&"
import script from "./DeliveryWuliu.vue?vue&type=script&lang=js&"
export * from "./DeliveryWuliu.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryWuliu.vue?vue&type=style&index=0&id=cb4f5850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4f5850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb4f5850')) {
      api.createRecord('cb4f5850', component.options)
    } else {
      api.reload('cb4f5850', component.options)
    }
    module.hot.accept("./DeliveryWuliu.vue?vue&type=template&id=cb4f5850&scoped=true&", function () {
      api.rerender('cb4f5850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/DeliveryWuliu.vue"
export default component.exports